
















































import { Component, Vue } from "vue-property-decorator";
import {
  KitDinamico,
  ItemKitDinamico,
  KitsDinamicosService,
  AssociarProdutoItemKitDinamicoCommand,
} from "@/services/kits-dinamicos.service";
import { Produto } from "@/services/produtos.service";
import Loading from "@/shared/components/loading.vue";
import DataTable from "@/shared/components/data-table.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import Modal from "@/shared/components/modal.vue";
import { moeda } from "@/shared/filters";

@Component({
  components: {
    Loading,
    Modal,
    DataTable,
    Tooltip,
  },
  filters: {
    moeda,
  },
})
export default class AssociarProdutoKitDinamico extends Vue {
  kitdinamico: KitDinamico | null = null;

  loading = false;

  valid = false;

  txtPesquisa = "";

  itens: Produto[] = [];

  selected: Produto[] = [];

  itemKitDinamico: ItemKitDinamico | null = null;

  headers = [
    { value: "descricao", text: "Produtos para Selecionar", sortable: false },
    { value: "valorVenda", text: "Valor de Venda" },
  ];

  async fetchItensKitsDinamicos() {
    this.loading = true;

    try {
      this.itens = await KitsDinamicosService.listarProdutosKitsDinamicos(
        this.txtPesquisa
      );
    } finally {
      this.loading = false;
    }
  }

  fechar(res: boolean) {
    const modal = this.$refs.modal as Modal;
    this.txtPesquisa = "";
    modal.close(res);
  }

  async salvar() {
    if (this.selected.length == 0) {
      this.txtPesquisa = "";
      return this.fechar(false);
    }
    if (this.itemKitDinamico) {
      if (
        this.itemKitDinamico.kitDinamico &&
        this.itemKitDinamico.idItemKitDinamico
      ) {
        if (this.itemKitDinamico.kitDinamico.idKitDinamico) {
          const command: AssociarProdutoItemKitDinamicoCommand = {
            idKitDinamico: this.itemKitDinamico.kitDinamico.idKitDinamico,
            idItemKitDinamico: this.itemKitDinamico.idItemKitDinamico,
            produtos: this.selected.map((x) => x.idProduto),
          };

          this.loading = true;
          try {
            await KitsDinamicosService.associarProdutos(command);
          } finally {
            this.loading = false;
            this.txtPesquisa = "";
          }
        }
      }
    }

    return this.fechar(true);
  }

  public async novoItemProdutoKitDinamico(itemKitDinamico: ItemKitDinamico) {
    const modal = this.$refs.modal as Modal;
    this.itemKitDinamico = itemKitDinamico;
    if (itemKitDinamico.produtos) {
      this.selected = [...itemKitDinamico.produtos];
    }
    this.itens = [...this.selected];

    return modal.open();
  }
}
